import mapValues from 'lodash/mapValues';

export const withContext = reducer => (state, action) => {
    return reducer(state, action, state);
};

export const combineReducers = reducers => (state = {}, action, shared) => {
    return mapValues(reducers, (reducer, key) =>
        reducer(state[key], action, shared)
    );
};
